import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Tooltip } from '@/components/ui/daisy';
import { TooltipPlacement } from '@/components/ui/daisy/tooltip/types';

type LimitedEditionWrapperProps = {
  isLimitedEdition: boolean;
  children: ReactNode;
  className?: string;
  placement?: TooltipPlacement;
};

export default function LimitedEditionWrapper({
  isLimitedEdition,
  children,
  className,
  placement,
}: LimitedEditionWrapperProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'adminPage.editCourseRules',
  });

  return (
    <ConditionalWrapper
      condition={isLimitedEdition}
      wrapper={
        <Tooltip
          text={t('cantModify')}
          placement={placement}
          className={className}
        />
      }
    >
      {children}
    </ConditionalWrapper>
  );
}
